"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
const core_1 = require("@angular/core");
const translate_1 = require("./../../../translate/src/translate");
const translations_1 = require("./translations");
let AlarmUiResourceManager = 
/**
 * This resource manager handles the registration of the texts of this module in the translation service.
 * The best way is to inject this manager in the module constructor.
 * @class AlarmUiResourceManager
 * @classdesc Resource class to handle texts in different languages of the current module
 * @author insite-gmbh
 */
class AlarmUiResourceManager {
    /**
     * The class constructor adds the texts to the translation service.
     * @param {InaxTranslateService} _translations The translationservice handles the UI Text translation.
    */
    constructor(_translations) {
        this._translations = _translations;
        _translations.addTranslations(translations_1.alarmUiTranslations);
    }
};
AlarmUiResourceManager = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [translate_1.InaxTranslateService])
], AlarmUiResourceManager);
exports.AlarmUiResourceManager = AlarmUiResourceManager;
